<div class="confirmation-modal">
    <span>Please confirm this action</span>
    <div class="actions">
        <button class="confirm" (click)="confirm()">Confirm</button>
        <button class="cancel" (click)="cancel()">Cancel</button>
    </div>
</div>
